import homePageTranslation from './translations/homePageTranslation.json'
import paginationTranslation from './translations/paginationTranslation.json'

const translations = {
  en: {
    homePageTranslation: { ...homePageTranslation.en },
    paginationTranslation: { ...paginationTranslation.en }
  },
  sv: {
    homePageTranslation: { ...homePageTranslation.sv },
    paginationTranslation: { ...paginationTranslation.sv }
  }
}

export default translations
